var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pt-0",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"start","justify":"center"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }